const contentStyles = `
  p {
    margin-top: 0;
  }

  html, body {
    cursor: text;
  }

  html {
    font-size: 62.5%;
  }

  body {
    overflow-x: hidden;
    font-family: -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Roboto, Helvetica Neue, sans-serif;
    font-size: 1.4em;
    color: #212B36;
  }
  @media only screen and (max-device-width: 40em) {
    body {
      font-size: 1.6em;
    }
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0 0 1em 0;
    line-height: 1.4;
  }

  table {
    width: 100%;
  }

  table, td, th {
    border: 1px dashed #CCC;
  }

  .readonly {
    color: #8c9196
  }
`;

export { contentStyles };
